import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LandingPage from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import SheharyarShahid from './pages/Sheharyar-Shahid';
import DeviceContextProvider from './lib/UserDeviceContext';
import QuickDemo from "./quickdemo/App"
function App(){
   return (<BrowserRouter>
   <Routes>
   <Route path='/' element={<Layout/>}>
     <Route index element={<LandingPage/>}/>
     <Route path="sheharyar.shahid" element={<SheharyarShahid/>} />
     <Route path="quickDemo" element={<QuickDemo/>} />
   </Route>
   </Routes>
   </BrowserRouter>)
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>

    <App />

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
